import {command, queryAll, queryOne, querySearch} from "../utils/api";

const GET_CATEGORIES_URL = `${process.env.PUBLIC_URL}/api/v1/r/categories`;
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_CATEGORIES_COMPLETED = 'GET_CATEGORIES_COMPLETED';
export const GET_CATEGORIES_FAILED = 'GET_CATEGORIES_FAILED';
export function getCategories({salonId}) {
  const filter = {
    where: {salonId: {eq: salonId}},
    order: 'name ASC',
  };
  return queryAll(GET_CATEGORIES_URL, filter, GET_CATEGORIES, GET_CATEGORIES_COMPLETED, GET_CATEGORIES_FAILED);
}

export const SEARCH_CATEGORIES = 'SEARCH_CATEGORIES';
export const SEARCH_CATEGORIES_COMPLETED = 'SEARCH_CATEGORIES_COMPLETED';
export const SEARCH_CATEGORIES_FAILED = 'SEARCH_CATEGORIES_FAILED';
export const searchCategories = querySearch(GET_CATEGORIES_URL, SEARCH_CATEGORIES, SEARCH_CATEGORIES_COMPLETED,
  SEARCH_CATEGORIES_FAILED, ['name', 'parentName', 'taxGroupName']);

export const GET_CATEGORY = 'GET_CATEGORY';
export const GET_CATEGORY_COMPLETED = 'GET_CATEGORY_COMPLETED';
export const GET_CATEGORY_FAILED = 'GET_CATEGORY_FAILED';
export function getCategory({categoryId}) {
  return queryOne(GET_CATEGORIES_URL, {where: {categoryId}}, GET_CATEGORY, GET_CATEGORY_COMPLETED, GET_CATEGORY_FAILED);
}

export const GET_CATEGORY_TREE = 'GET_CATEGORY_TREE';
export const GET_CATEGORY_TREE_COMPLETED = 'GET_CATEGORY_TREE_COMPLETED';
export const GET_CATEGORY_TREE_FAILED = 'GET_CATEGORY_TREE_FAILED';
export function getCategoryTree({salonId}) {
  return queryOne(`${process.env.PUBLIC_URL}/api/v1/r/categoryTrees`, {where: {salonId}}, GET_CATEGORY_TREE,
    GET_CATEGORY_TREE_COMPLETED, GET_CATEGORY_TREE_FAILED);
}

const CATEGORY_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/category`;
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const ADD_CATEGORY_COMPLETED = 'ADD_CATEGORY_COMPLETED';
export const ADD_CATEGORY_FAILED = 'ADD_CATEGORY_FAILED';
export const addCategory = command(CATEGORY_ACTION_URL + '/addCategory', ADD_CATEGORY, ADD_CATEGORY_COMPLETED,
  ADD_CATEGORY_FAILED);

export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const UPDATE_CATEGORY_COMPLETED = 'UPDATE_CATEGORY_COMPLETED';
export const UPDATE_CATEGORY_FAILED = 'UPDATE_CATEGORY_FAILED';
export const updateCategory = command(CATEGORY_ACTION_URL + '/updateCategory', UPDATE_CATEGORY,
  UPDATE_CATEGORY_COMPLETED, UPDATE_CATEGORY_FAILED);

export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const DELETE_CATEGORY_COMPLETED = 'DELETE_CATEGORY_COMPLETED';
export const DELETE_CATEGORY_FAILED = 'DELETE_CATEGORY_FAILED';
export const deleteCategory = command(
  CATEGORY_ACTION_URL + '/deleteCategory',
  DELETE_CATEGORY,
  DELETE_CATEGORY_COMPLETED,
  DELETE_CATEGORY_FAILED
);

export const SHOW_DELETE_CATEGORY_MODAL = 'SHOW_DELETE_CATEGORY_MODAL';
export function showDeleteCategoryModal(category) {
  return {type: SHOW_DELETE_CATEGORY_MODAL, payload: category};
}

export const HIDE_DELETE_CATEGORY_MODAL = 'HIDE_DELETE_CATEGORY_MODAL';
export function hideDeleteCategoryModal() {
  return {type: HIDE_DELETE_CATEGORY_MODAL};
}



// WEBPACK FOOTER //
// ./src/Category/actions.js